export const composeShadow = ({ x, y, blur, spread, color, }) => `${x} ${y} ${blur} ${spread} ${color}`;
